import React, {useEffect, useState} from "react";
import {makeStyles, TextField, Tooltip, Typography} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import PropTypes from "prop-types";
import DoneIcon from '@material-ui/icons/Done'
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import Tr from "translations/Translations";
import WorkableIconButton from "components/button/WorkableIconButton";
import formatAmountNumber from "libs/formatAmountNumber";

const useStyles = makeStyles(theme => ({
    edit: {
        width: 'auto'
    },
    error: {
        fontSize: '0.8em'
    }
}));

const scoreRegex = /^((([0-9]{1,2}?)([,][0-9]{0,2})?)|100|)$/;
const emptyRegex = /^$/
const emptyEditMode = {enabled: false, value: "", error: false, working: false}
function OffersEvaluationScoreColumn(
    {
        editable,
        offerEvaluationRow,
        offerEvaluationCriterion,
        updateScore
    }) {

    const classes = useStyles();
    const [editMode, setEditMode] = useState(emptyEditMode);

    useEffect(() => {
        if (editMode)
            setEditMode(emptyEditMode);
        // eslint-disable-next-line
    }, [offerEvaluationRow])

    const onScoreClick = () => {
        const value = editMode.value;
        if (emptyRegex.test(value)) {
            setEditMode(emptyEditMode);
        } else if (scoreRegex.test(value)) {
            const number = parseFloat(value.replace(/[,]/, "."));
            if(number <= offerEvaluationCriterion.weight) {
                setEditMode(x => ({...x, working: true}))
                updateScore(number, offerEvaluationCriterion).finally(()=> setEditMode(emptyEditMode));
            }
        }
    }

    const handleKeyPress = (e) => {
        if (!editMode.error && e.key === 'Enter') {
            onScoreClick();
        }
    }

    const handleChange = (e) => {
        const value = e.target.value.replace(/[.]/, ",");
        if (emptyRegex.test(value) || scoreRegex.test(value)) {
            const number = parseFloat(value.replace(/[,]/, "."));
            const error = number > offerEvaluationCriterion.weight;
            setEditMode(x => ({...x, value, error}))
        }
    }

    return (<GridBlock column>
        <GridBlock justify='space-between' alignItems="center" wrap='nowrap'>
            {editMode.enabled ?
                <Tooltip title={Tr('criterium_points')}>
                <TextField
                    className={classes.edit}
                    onChange={e => handleChange(e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    disabled={!editable}
                    value={editMode.value}
                    error={editMode.error}
                /></Tooltip> :
                <Typography variant="body2">{formatAmountNumber(offerEvaluationCriterion.score, '-')}</Typography>
            }
            {offerEvaluationCriterion.editable && <>
                {editMode.enabled ?
                    <WorkableIconButton
                        Icon={DoneIcon}
                        onClick={onScoreClick}
                        color='primary'
                        disabled={editMode.error || !editable}
                        working={editMode.working}
                    /> :
                    <WorkableIconEditButton
                        onClick={() => {
                            setEditMode({enabled: true, value: formatAmountNumber(offerEvaluationCriterion.score, '-'), error: (offerEvaluationCriterion.score > offerEvaluationCriterion.weight), working: false});
                        }}
                        color='primary'
                        disabled={!editable}
                    />}
            </>
            }

        </GridBlock>
        {editMode.error && <Typography className={classes.error} color='error' variant='body2'>{Tr("score_exceed_weight", {value: formatAmountNumber(offerEvaluationCriterion.weight, '-')})}</Typography>}
    </GridBlock>)
}

OffersEvaluationScoreColumn.propTypes = {
    editable: PropTypes.bool.isRequired,
    offerEvaluationRow: PropTypes.object.isRequired,
    offerEvaluationCriterion: PropTypes.object.isRequired,
    updateScore: PropTypes.func.isRequired
}

export default OffersEvaluationScoreColumn;

